import { Card, CardTitle, Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TransactionValidationPageSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="rounded" width="100%" height={48} />
      <Styles.MainContainer>
        <Card showBorder={false}>
          <CardTitle>
            <Skeleton variant="text" width={120} height={24} />
          </CardTitle>
          <Styles.ProductsCardContainer>
            <Styles.LineItemBlock>
              <Styles.LineItemRow>
                <Skeleton variant="rounded" width={88} height={88} />
                <Styles.LineItemInfo>
                  <Skeleton variant="text" width={180} height={20} />
                  <Skeleton variant="text" width={100} height={14} />
                  <Skeleton variant="text" width={70} height={20} />
                </Styles.LineItemInfo>
              </Styles.LineItemRow>
              <Styles.LineItemChipsRow>
                <Skeleton variant="rounded" width={90} height={24} />
                <Skeleton variant="rounded" width={110} height={24} />
              </Styles.LineItemChipsRow>
              <Skeleton variant="rounded" width="100%" height={64} />
            </Styles.LineItemBlock>
            <Styles.LineItemBlock>
              <Styles.LineItemRow>
                <Skeleton variant="rounded" width={88} height={88} />
                <Styles.LineItemInfo>
                  <Skeleton variant="text" width={160} height={20} />
                  <Skeleton variant="text" width={90} height={14} />
                  <Skeleton variant="text" width={70} height={20} />
                </Styles.LineItemInfo>
              </Styles.LineItemRow>
              <Styles.LineItemChipsRow>
                <Skeleton variant="rounded" width={90} height={24} />
                <Skeleton variant="rounded" width={110} height={24} />
              </Styles.LineItemChipsRow>
              <Skeleton variant="rounded" width="100%" height={64} />
            </Styles.LineItemBlock>
            <Styles.LineItemBlock>
              <Styles.LineItemRow>
                <Skeleton variant="rounded" width={88} height={88} />
                <Styles.LineItemInfo>
                  <Skeleton variant="text" width={200} height={20} />
                  <Skeleton variant="text" width={110} height={14} />
                  <Skeleton variant="text" width={70} height={20} />
                </Styles.LineItemInfo>
              </Styles.LineItemRow>
              <Styles.LineItemChipsRow>
                <Skeleton variant="rounded" width={90} height={24} />
                <Skeleton variant="rounded" width={110} height={24} />
              </Styles.LineItemChipsRow>
              <Skeleton variant="rounded" width="100%" height={64} />
            </Styles.LineItemBlock>
            <Divider />
            <Styles.SummaryLines>
              <Skeleton variant="text" width="60%" height={16} />
              <Skeleton variant="text" width="40%" height={16} />
            </Styles.SummaryLines>
          </Styles.ProductsCardContainer>
        </Card>

        <Card showBorder={false}>
          <CardTitle>
            <Skeleton variant="text" width={100} height={24} />
          </CardTitle>
          <Styles.SummaryCardContainer>
            <Styles.SummaryLines>
              <Skeleton variant="text" width="70%" height={18} />
              <Skeleton variant="text" width="50%" height={16} />
              <Skeleton variant="text" width="60%" height={16} />
              <Skeleton variant="text" width="45%" height={16} />
            </Styles.SummaryLines>
            <Skeleton variant="rounded" width="100%" height={64} />
            <Skeleton variant="rounded" width="100%" height={80} />
            <Styles.SummaryActionsContainer>
              <Skeleton variant="rounded" width="100%" height={40} />
              <Skeleton variant="rounded" width="100%" height={40} />
            </Styles.SummaryActionsContainer>
          </Styles.SummaryCardContainer>
        </Card>
      </Styles.MainContainer>
    </Styles.Container>
  )
}

export default TransactionValidationPageSkeleton
